
import Component, { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table";
import { RouterNameEnum } from "@/router/router.types";
import { Vue } from "vue-property-decorator";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
    }
})

export default class CosmetologCard extends mixins (ProxyTableData, SalaryCalculationsTable) {

    goToNewRule() {
        Vue.router.push({
            name: RouterNameEnum.CreateNewRule,
            params: {
                id: '1'
            }
        })
    }
    goToNewCriteria() {
        Vue.router.push({
            name: RouterNameEnum.CreateNewCriteria,
            params: {
                id: '1'
            }
        })
    }

    goToWage() {
        Vue.router.push({
            name: RouterNameEnum.WageCalculationScheme,
        })
    }

    async created() {
        this.formReady = true
    }

}
